import styled from 'styled-components';

export const TravellerCont = styled.div`
    border-radius: 0.4rem;
    background-color: #ffffff;
    margin: ${p => p.margin ? p.margin : ''};
`;
export const TravellerHeader = styled.div`
    padding: 2.3rem 3rem 2rem 3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    h3{
        font-family: 'Rubik';
        font-size: 1.8rem;
        line-height: 2.4rem;
        font-weight: 600;
        color: ${p => p.theme ? p.theme.colors.black.base : '#141823'};
    }
    .infoText{
        padding: 1rem;
        border-radius: 0.2rem;
        background-color: #e9f6ea;
        display: inline-flex;
        font-size: 1.4rem;
        color: #2276e3;
        cursor: pointer;
        margin-left: auto;
    }
`;
